<app-loader *ngIf="showLoader"></app-loader>
<div class="inner-wrapper">
    <app-option-selection></app-option-selection>
    <form class="form-field" [formGroup]="loginExist" novalidate>
        <div class="loginexist-name">
            <h3 *ngIf="userNameFromStorage != ''">Hello, <span class="text-pink"><strong>{{userNameFromStorage}}</strong></span></h3>
            <div class="client-code-details">
                <span class="client-code">{{clientCodeFromStorage}}</span>
                <button type="button" class="link-button" (click)="changeLogin()">Switch Account</button>
            </div>
        </div>
        <div class="label--wrapper">
            <label id="loginexistPinLabel">Unlock Using PIN</label>
            <button type="button" class="link-button" (click)="forgotMPIN()">FORGOT PIN</button>
        </div>

        <div class="otp-verifications-input">
            <div class="otp-box" role="group" aria-labelledby="loginexistPinLabel" [attr.aria-invalid]="incorrectPIN ? 'true' : null" [attr.aria-describedby]="incorrectPIN ? 'loginexistPinError' : null">
                <div class="otp-box">

                    <input
                    [ngClass]="{'errorbox': incorrectPIN == true}"
                    type="password" inputmode="numeric"
                    maxlength="1"
                    #pinOne
                    [(ngModel)]="otpArr[0]"
                    formControlName="pinDigitOne"
                    autocomplete="off"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\.*)\./g, '$1');"
                    matInput
                    (keydown)="onKeyUpHandleFocus($event,0)"
                    (input)="handleInput($event,0)"
                    (focus)="onFocusSelect($event)"
                    aria-label="Digit 1 of 6"
                    />
                    <input
                    [ngClass]="{'errorbox': incorrectPIN == true}"
                    type="password" inputmode="numeric"
                    maxlength="1"
                    #pinTwo
                    [(ngModel)]="otpArr[1]"
                    formControlName="pinDigitTwo"
                    autocomplete="off"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\.*)\./g, '$1');"
                    matInput
                    (keydown)="onKeyUpHandleFocus($event,1)"
                    (input)="handleInput($event,1)"
                    (focus)="onFocusSelect($event)"
                    aria-label="Digit 2 of 6"
                    />
                    <input
                    [ngClass]="{'errorbox': incorrectPIN == true}"
                    type="password" inputmode="numeric"
                    maxlength="1"
                    #pinThree
                    [(ngModel)]="otpArr[2]"
                    formControlName="pinDigitThree"
                    autocomplete="off"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\.*)\./g, '$1');"
                    matInput
                    (keydown)="onKeyUpHandleFocus($event,2)"
                    (input)="handleInput($event,2)"
                    (focus)="onFocusSelect($event)"
                    aria-label="Digit 3 of 6"
                    />
                    <input
                    [ngClass]="{'errorbox': incorrectPIN == true}"
                    type="password" inputmode="numeric"
                    maxlength="1"
                    #pinFour
                    [(ngModel)]="otpArr[3]"
                    formControlName="pinDigitFour"
                    autocomplete="off"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\.*)\./g, '$1');"
                    matInput
                    (keydown)="onKeyUpHandleFocus($event,3)"
                    (input)="handleInput($event,3)"
                    (focus)="onFocusSelect($event)"
                    aria-label="Digit 4 of 6"
                    />
                    <input
                    [ngClass]="{'errorbox': incorrectPIN == true}"
                    type="password" inputmode="numeric"
                    maxlength="1"
                    #pinFive
                    [(ngModel)]="otpArr[4]"
                    formControlName="pinDigitFive"
                    autocomplete="off"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\.*)\./g, '$1');"
                    matInput
                    (keydown)="onKeyUpHandleFocus($event,4)"
                    (input)="handleInput($event,4)"
                    (focus)="onFocusSelect($event)"
                    aria-label="Digit 5 of 6"
                    />
                    <input
                    [ngClass]="{'errorbox': incorrectPIN == true}"
                    type="password" inputmode="numeric"
                    maxlength="1"
                    #pinSix
                    [(ngModel)]="otpArr[5]"
                    formControlName="pinDigitSix"
                    autocomplete="off"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\.*)\./g, '$1');"
                    matInput
                    (keydown)="onKeyUpHandleFocus($event,5)"
                    (input)="handleInput($event,5)"
                    (focus)="onFocusSelect($event)"
                    (keydown.enter)="verifyPin()"
                    aria-label="Digit 6 of 6"
                    />
                </div>
            </div>
            <div *ngIf="incorrectPIN" role="alert" id="loginexistPinError">
                <span class="error-text">{{ pinError }}</span>
            </div>
        </div>
        <div id="example-container"  data-theme ='auto'></div>
        <button class="btn-dark btn-block" #btnVerified id="btnVerifyOTPMPIN" [disabled]="loginExist.invalid" (click)="verifyPin()">Proceed</button>
</form>
</div>